// src/api/activityLogApi.js
import apiClient from "./axios";

function getCurrentEndpoint() {
  if (typeof window === "undefined") return "/activity-logs/"; // SSR / node safety

  const path = window.location.pathname.toLowerCase();

  if (path.includes("raise-ticket") || path.includes("raise_ticket")) {
    return "/activity-logs/ticket-history/";
  }

  if (path.includes("request-issuance") || path.includes("request_issuance")) {
    return "/activity-logs/request-history/";
  }

  return "/activity-logs/";
}

const activityLogApi = {
  getAll: async (params = {}) => {
    const endpoint = getCurrentEndpoint();

    const {
      page = 1,
      page_size = 10,
      object_id,
      resource,
      action_type,
      search = "",
      date_range,
      start_date,
      end_date,
      from_datetime,
      to_datetime,
    } = params;

    const response = await apiClient.get(endpoint, {
      params: {
        page,
        page_size,
        object_id: object_id || undefined,
        resource: resource || undefined,
        action_type: action_type || undefined,
        search: search.trim() || undefined,
        date_range: date_range || undefined,
        start_date: start_date || undefined,
        end_date: end_date || undefined,
        from_datetime: from_datetime || undefined,
        to_datetime: to_datetime || undefined,
      },
    });

    return response.data;
  },
};

export default activityLogApi;
